import React from "react"
import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"
import delete_icon from "../../../../assets/images/delete_red.svg"
import styles from "./Chargers.module.scss"

interface ChargerProps {
    index: number
    count: number
    totalCount: number
    removeHandler: () => void
    formik: any
}

const Charger = ({ index, count, totalCount, removeHandler, formik }: ChargerProps) => {
    const { values, setFieldValue, errors, touched } = formik
    const charger = values.chargers[index]

    const chargerErrors = errors.chargers?.[index] || {}
    const chargerTouched = touched.chargers?.[index] || {}

    return (
        <div className={styles.payment_container}>
            <div className={styles.heading_container}>
                <div className={styles.heading}>Charger {count}*</div>
                {totalCount > 1 && (
                    <div onClick={removeHandler} className={styles.remove} style={{ cursor: "pointer" }}>
                        <img src={delete_icon} alt="delete_icon" />
                    </div>
                )}
            </div>

            <div className={`${styles.section} ${styles.section_1}`}>
                <MultiSelectDropdown
                    title="Charger Type"
                    options={[
                        { id: "AC", title: "AC" },
                        { id: "DC", title: "DC" },
                    ]}
                    id="type"
                    onChange={() => {}}
                    selectedOptions={charger.type ? [charger.type] : []}
                    selectionType={"single"}
                    onSelect={(value: any) => {
                        setFieldValue(`chargers[${index}].type`, value)
                    }}
                    height="44px"
                    error={charger.type === null}
                    showError={formik.submitCount > 0}
                />
                <SearchInputV2
                    additionalValidation="0"
                    type="number"
                    onSearch={(value: any) => setFieldValue(`chargers[${index}].quantity`, value)}
                    value={charger.quantity}
                    placeholder={"Enter Quantity"}
                    height="44px"
                    error={!!chargerTouched.quantity && !!chargerErrors.quantity}
                    showError={formik.submitCount > 0}
                />
                <SearchInputV2
                    type="number"
                    onSearch={(value: any) => setFieldValue(`chargers[${index}].rating`, value)}
                    value={charger.rating}
                    placeholder={"Enter Rating"}
                    height="44px"
                    error={!!chargerTouched.rating && !!chargerErrors.rating}
                    showError={formik.submitCount > 0}
                />{" "}
            </div>
        </div>
    )
}

const Chargers = ({ formik }: { formik: any }) => {
    const { values, setFieldValue } = formik

    const addSurveyChargers = () => {
        const newCharger = {
            id: Date.now(),
            type: null,
            quantity: "",
            rating: "",
        }
        setFieldValue("chargers", [...values.chargers, newCharger])
    }

    const removeSurveyChargers = (id: number) => {
        const filtered = values.chargers.filter((c: any) => c.id !== id)
        setFieldValue("chargers", filtered)
    }

    return (
        <div className={`${styles.container}`}>
            <div className={styles.header}>
                <div className={styles.title}>CHARGER DETAILS</div>
            </div>
            <div>
                {values.chargers.map((item: any, index: number) => (
                    <Charger
                        key={item.id}
                        count={index + 1}
                        totalCount={values.chargers.length}
                        removeHandler={() => removeSurveyChargers(item.id)}
                        index={index}
                        formik={formik}
                    />
                ))}
            </div>
            <div className={styles.header}>
                <div className={styles.cta} onClick={addSurveyChargers} style={{ cursor: "pointer" }}>
                    +Add Charger
                </div>
            </div>
        </div>
    )
}

export default Chargers
